import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import LoadingIndicatorBase from 'src/components/LoadingIndicator';
import { TermsType, goRecentTerms } from 'src/utils/terms/zendeskApi';
const LoadingIndicator = styled(LoadingIndicatorBase)`
  position: fixed;
  color: ${({
  theme
}) => theme.color.content7};
`;
const CookiePolicyView = () => {
  const router = useRouter();
  useEffect(() => {
    if (!router.isReady) return;
    const query = router.query;
    const requestedLang = Array.isArray(query.lang) ? query.lang[0] : query.lang;

    // cookie policy는 영어와 한국어 문서만 지원함
    // @see https://hpcnt.slack.com/archives/C0ADQS0QZSR/p1773367597069539?thread_ts=1773232916.995069&cid=C0ADQS0QZSR
    const lang = requestedLang === 'ko' ? 'ko' : 'en-us';
    goRecentTerms(TermsType.cookiePolicy, lang);
  }, [router.isReady, router.query]);
  return <LoadingIndicator size={32} data-sentry-element="LoadingIndicator" data-sentry-component="CookiePolicyView" data-sentry-source-file="CookiePolicy.tsx" />;
};
export default CookiePolicyView;